import { createBrowserRouter, createMemoryRouter, type RouteObject } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { Layout } from './components/Layout';
import { UIProvider } from './components/ui';
import { Home, Section, TagPage, YearPage } from './routes/Feeds';
import { CommunityPage, Communities, IdeaPage, Ideas, Tags } from './routes/Social';
import { Messages, NewPost, Notifications, PostPage, Profile, SearchPage, Settings } from './routes/Pages';
import { About, Guidelines, Help, Impressum, NotFound, Privacy, Terms } from './routes/Static';

export const routes: RouteObject[] = [{
  element: <UIProvider><Layout /></UIProvider>,
  children: [
    { path: '/', element: <Home /> },
    { path: '/y/:year', element: <YearPage /> },
    { path: '/t/:tag', element: <TagPage /> },
    { path: '/tags', element: <Tags /> },
    { path: '/ideas', element: <Ideas /> },
    { path: '/ideas/:id', element: <IdeaPage /> },
    { path: '/c', element: <Communities /> },
    { path: '/c/:slug', element: <CommunityPage /> },
    { path: '/p/:id', element: <PostPage /> },
    { path: '/u/:handle', element: <Profile /> },
    { path: '/new', element: <NewPost /> },
    { path: '/search', element: <SearchPage /> },
    { path: '/notifications', element: <Notifications /> },
    { path: '/messages', element: <Messages /> },
    { path: '/settings', element: <Settings /> },
    { path: '/kindness', element: <Section k="kindness" /> },
    { path: '/forgotten', element: <Section k="forgotten" /> },
    { path: '/there', element: <Section k="there" /> },
    { path: '/capsule', element: <Section k="capsule" /> },
    { path: '/about', element: <About /> },
    { path: '/help', element: <Help /> },
    { path: '/guidelines', element: <Guidelines /> },
    { path: '/privacy', element: <Privacy /> },
    { path: '/terms', element: <Terms /> },
    { path: '/impressum', element: <Impressum /> },
    { path: '*', element: <NotFound /> },
  ],
}];

// The private Claude preview page cannot use real web addresses, so it keeps them in memory.
const router = import.meta.env.MODE === 'artifact' ? createMemoryRouter(routes) : createBrowserRouter(routes);
export default function App() { return <RouterProvider router={router} />; }
